import swal from "sweetalert2";
import { pluralize } from "humanize-plus";
import { uncapitalize } from "../../../services/string-service";

export async function confirmNegativeWithPositives(nomenclature, positivesCount) {
	try {
		const result = await swal.fire({
			title: "Confirm Action",
			html: `<p>
				The period that you have selected already has ${positivesCount} existing ${pluralize(positivesCount, uncapitalize(nomenclature.PositiveReport))}. 
				Are you sure you want to file a ${uncapitalize(nomenclature.NegativeReport)} for this period?
			</p>`,
			showCloseButton: true,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Confirm"
		});
		
		return !!result.value;
	}
	catch(error) {		
		return false;
	}
}